
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importe suas traduções
import enMessages from "./i18n/en";
import ptBRMessages from "./i18n/pt_BR";
import esMessages from "./i18n/es";

const resources = {
  pt_BR: { translation: ptBRMessages },
  en_US: { translation: enMessages },
  es_ES: { translation: esMessages },
};

let initialLang = window.navigator.userLanguage || (window.navigator.language && (["pt-BR", "en-US","es-ES"].includes(window.navigator.language)))?  window.navigator.language : 'en-US';
initialLang = initialLang.replace('-','_');

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang,
    fallbackLng: 'en_US',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;